<template>
  <div class="section-main__warp">
    <div class="lift-content">
      <div class="lift-item" v-for="(item, key) in liftList" :key="item.deviceCode">
        <div class="item-header">
          <div class="item-left">
            <div class="item-vertical-line"></div>
            <div class="item-text">{{ item.thirdDeviceName }}</div>
          </div>
          <div class="item-circle">
            <div class="text" v-if="key == 0 || key == 1">客</div>
            <div class="text" v-if="key == 2 || key == 3">货</div>
          </div>
        </div>
        <div class="item-content">
          <div class="item-left">
            <div class="item-img">
              <img v-if="key == 0 || key == 1" src="../images/passengerElevator.png" alt="" width="110" height="110">
              <img v-if="key == 2 || key == 3" src="../images/freightElevator.png" alt="" width="110" height="110">
            </div>
          </div>
          <div class="item-right">
            <div class="right-content">
              <div class="label">设备状态：</div>
              <div class="value">{{ floorStatusRender(item.floorStatus) }}</div>
            </div>
            <div class="right-content">
              <div class="label">运行状态：</div>
              <div class="value">{{ floorRunStatusRender(item.floorRunStatus) }}</div>
            </div>
            <div class="right-content">
              <div class="label">所在楼层：</div>
              <div class="value">{{ item.currentFloor }}</div>
            </div>
            <div class="right-content">
              <el-button icon="el-icon-video-camera" @click="liftCameraPlay(item)">实时监控</el-button>
            </div>
          </div>
        </div>
      </div>
      <dhWindowPlayer ref="videoPlayer" v-if="miniPlayerShow"></dhWindowPlayer>
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import DhWindowPlayer from "@src/components/business/dh-window-player/index.vue";
export default {
  components: {
    DhWindowPlayer
  },
  data() {
    return {
      liftList: [
        {
          thirdDeviceId: '',
          thirdDeviceName: '',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
        {
          thirdDeviceId: '',
          thirdDeviceName: '',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
        {
          thirdDeviceId: '',
          thirdDeviceName: '',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
        {
          thirdDeviceId: '',
          thirdDeviceName: '',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
      ],
      miniPlayerShow: false,
      timer: null
    }
  },
  created() {
    this.getLiftList()
  },
  mounted() {
    const self = this
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(self.getLiftList, 5000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getLiftList() {
      this.liftList = [
        {
          thirdDeviceId: '',
          thirdDeviceName: '1#电梯（7#电梯01）',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
        {
          thirdDeviceId: '',
          thirdDeviceName: '2#电梯（7#电梯02 ）',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
        {
          thirdDeviceId: '',
          thirdDeviceName: '3#电梯（1#冷库-电梯01）',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
        {
          thirdDeviceId: '',
          thirdDeviceName: '4#电梯（1#冷库-电梯02）',
          floorStatus: '',
          floorRunStatus: '',
          currentFloor: '',
          relevanceCameraName: '',
          relevanceCameraId: '',
        },
      ]
      let params = {
        currentStatusType: "lift"
      };
      this.$fetch(api.queryLiftList, params).then((response) => {
        if (response.success) {
          this.liftList = []
          for (let i = 0; i < response.returnObj.length; i++) {
            let floorStatus = ""
            let floorRunStatus = ""
            let currentFloor = ""
            for (let j = 0; j < response.returnObj[i].deviceStatusList.length; j++) {
              if (Number(response.returnObj[i].deviceStatusList[j].currentStatusValue) == Number(response.returnObj[i].deviceStatusList[j].normalValue)) {
                if (response.returnObj[i].deviceStatusList[j].currentStatusKey == "normal" || response.returnObj[i].deviceStatusList[j].currentStatusKey == "overhaul" || response.returnObj[i].deviceStatusList[j].currentStatusKey == "fault") {
                  floorStatus = response.returnObj[i].deviceStatusList[j].currentStatusKey
                }
                if (response.returnObj[i].deviceStatusList[j].currentStatusKey == "up" || response.returnObj[i].deviceStatusList[j].currentStatusKey == "down" || response.returnObj[i].deviceStatusList[j].currentStatusKey == "stop") {
                  floorRunStatus = response.returnObj[i].deviceStatusList[j].currentStatusKey
                }
              } else if (response.returnObj[i].deviceStatusList[j].currentStatusKey == "upordown") {
                if (response.returnObj[i].deviceStatusList[j].currentStatusValue == "1.0" || response.returnObj[i].deviceStatusList[j].currentStatusValue == "2.0") {
                  floorRunStatus = 'up'
                } else if (response.returnObj[i].deviceStatusList[j].currentStatusValue == "3.0" || response.returnObj[i].deviceStatusList[j].currentStatusValue == "4.0") {
                  floorRunStatus = 'down'
                } else {
                  floorRunStatus = 'others'
                }
              }
              if (response.returnObj[i].deviceStatusList[j].currentStatusKey == "floor") {
                currentFloor = Number(response.returnObj[i].deviceStatusList[j].currentStatusValue)
              }
            }
            this.liftList.push(
              {
                thirdDeviceId: response.returnObj[i].thirdDeviceId,
                thirdDeviceName: response.returnObj[i].thirdDeviceName + '（' + (((response.returnObj[i].cameraList) && (response.returnObj[i].cameraList.length > 0)) ? response.returnObj[i].cameraList[0].cameraName : "") + '）',
                floorStatus: floorStatus,
                floorRunStatus: floorRunStatus,
                currentFloor: currentFloor,
                relevanceCameraName: ((response.returnObj[i].cameraList) && (response.returnObj[i].cameraList.length > 0)) ? response.returnObj[i].cameraList[0].cameraName : "",
                relevanceCameraId: ((response.returnObj[i].cameraList) && (response.returnObj[i].cameraList.length > 0)) ? response.returnObj[i].cameraList[0].thirdCameraId : "",
              }
            )
          }
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    floorStatusRender(value) {
      if (value == 'normal') {
        return '正常'
      } else if (value == 'overhaul') {
        return '检修'
      } else if (value == 'fault') {
        return '故障'
      } else {
        return '--'
      }
    },
    floorRunStatusRender(value) {
      if (value == 'up') {
        return '上行'
      } else if (value == 'down') {
        return '下行'
      } else if (value == 'stop') {
        return '锁梯'
      } else {
        return '--'
      }
    },
    // 视频播放
    liftCameraPlay(data) {
      if (data.relevanceCameraId == '') {
        this.$message.warning('此电梯尚未绑定摄像头');
        return
      }
      let options = {
        playId: data.relevanceCameraId,
        playType: "live"
      }
      if (!options) {
        if (this.$refs.videoPlayer && this.$refs.videoPlayer.showPage) {
          this.$refs.videoPlayer.handleClose();
        }
        return;
      }
      this.miniPlayerShow = true;
      if (this.$refs.videoPlayer && this.$refs.videoPlayer.showPage) {
        this.$refs.videoPlayer.handleClose();
        setTimeout(() => {
          this.$refs.videoPlayer.showWnd(options);
        }, 500);
        return;
      }
      this.$nextTick(() => {
        this.$refs.videoPlayer.showWnd(options);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.lift-content {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 50px 150px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;

  .lift-item {
    width: 500px;
    height: 250px;
    margin: 38px 100px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(64, 122, 238, .4);

    .item-header {
      width: 100%;
      height: 26%;
      background-color: rgb(64, 122, 238);
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 1px;

      .item-left {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;

        .item-vertical-line {
          width: 5px;
          height: 30%;
          background-color: #ffffff;
          margin-left: 30px;
        }

        .item-text {
          margin-left: 10px;
        }
      }

      .item-circle {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid #ffffff;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .text {
          font-size: 16px;
        }
      }
    }

    .item-content {
      width: 100%;
      height: 74%;
      background-color: #ffffff;
      display: flex;

      .item-left {
        width: 32%;
        height: 100%;

        .item-img {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .item-right {
        width: 68%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        padding: 20px 0;

        .right-content {
          width: 40%;
          height: 30px;
          display: flex;
          align-items: center;

          .label {
            width: 60%;
            font-size: 15px;
            font-weight: bold;
          }

          .value {
            width: 40%;
            color: rgb(64, 122, 238);
            font-size: 16px;
            font-weight: bolder;
          }
        }
      }
    }
  }
}
</style>